export const routeName = 'privacy-policy';
export const slugs: Record<string, string> = {
	es: 'politica-de-privacidad',
	en: 'privacy-policy',
	ca: 'politica-de-privacitat',
	fr: 'politique-de-confidentialite',
	it: 'informativa-sulla-privacy',
};
export const sitemap = { changefreq: 'yearly', priority: '0.3', lastmod: '2026-09-02' };
